import fetch from '@adc/fetch'

export const getRestrictions = userId =>
  fetch
    .fromService('MS_UAA')
    .get(`/uaa/v1/user/${userId}/restrictions`, {
      queryParams: { size: 100 },
    })
    .then(({ body }) => body.content)

export const updateProductRestrictions = (userId, values) =>
  fetch
    .fromService('MS_UAA')
    .post(`/uaa/v1/user/${userId}/restrictions`, {
      body: {
        resource: 'BIDDING',
        actions: [
          'ONLINE_BIDDING_REGISTRATION',
          'ONLINE_REGULAR_BIDDING',
          'ONLINE_PROXY_BIDDING',
          'ONLINE_DIRECT_OFFER',
        ],
        deny_conditions: [
          {
            context: 'LISTING',
            type: 'PRODUCT_TYPE',
            values,
          },
        ],
      },
    })
    .then(({ body }) => body)

export const updateEditRestrictions = userId =>
  fetch
    .fromService('MS_UAA')
    .post(`/uaa/v1/user/${userId}/restrictions`, {
      body: {
        resource: 'USER_ACCOUNT',
        actions: ['EDIT_EMAIL', 'EDIT_PHONE'],
      },
    })
    .then(({ body }) => body)

export const deleteProductRestrictions = (userId, values) =>
  fetch
    .fromService('MS_UAA')
    .delete(`/uaa/v1/user/${userId}/restrictions`, {
      body: {
        resource: 'BIDDING',
        actions: ['ONLINE_BIDDING_REGISTRATION'],
        deny_conditions: [
          {
            context: 'LISTING',
            type: 'PRODUCT_TYPE',
            values,
          },
        ],
      },
    })
    .then(({ body }) => body)

export const deleteAllRestrictions = userId =>
  fetch
    .fromService('MS_UAA')
    .delete(`/uaa/v1/user/${userId}/restrictions/all`)
    .then(({ body }) => body)
